import { render, staticRenderFns } from "./ManageGroup.vue?vue&type=template&id=5bed42d4&scoped=true&"
import script from "./ManageGroup.vue?vue&type=script&lang=js&"
export * from "./ManageGroup.vue?vue&type=script&lang=js&"
import style0 from "./ManageGroup.vue?vue&type=style&index=0&id=5bed42d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bed42d4",
  null
  
)

export default component.exports